import { render } from "./imageUploader.vue?vue&type=template&id=254dc81e"
import script from "./imageUploader.vue?vue&type=script&lang=js"
export * from "./imageUploader.vue?vue&type=script&lang=js"

import exportComponent from "/builds/spsgn/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QUploader from 'quasar/src/components/uploader/QUploader.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QUploader,QImg,QIcon});
